import React, { Fragment } from 'react';
import { Flex, Text, Image, IconButton, Box, useColorMode } from '@chakra-ui/react';
import { GrDownload } from 'react-icons/gr';
import { AiFillFile } from 'react-icons/ai';
import { bgColor } from 'config/data';

const Unlockable = ({ unlockables }) => {
  const { colorMode } = useColorMode();
  const getIcon = (type) => {
    if (type === 1) return '/images/photo.svg';
    if (type === 2) return '/images/video.svg';
    if (type === 3) return '/images/music.svg';
    if (type === 4) return null;
    return '';
  };

  const getFormat = (type) => {
    if (type === 1) return 'JPG FORMAT';
    if (type === 2) return 'MKV FORMAT';
    if (type === 3) return 'WAV FORMAT';
    if (type === 4) return '';
    return '';
  };
  const getLink = (file) => {
    if (file.file_type === 1) return file.file_http_url;
    if (file.file_type === 2) return file.video_stream_urls.hls;
    if (file.file_type === 3) return file.file_http_url;
    if (file.file_type === 4) return file.file_http_url;
    return '';
  };

  return (
    <Fragment>
      <Text fontWeight="bold" mb="20px">
        Unlockable Content ⚡️
      </Text>
      <Flex
        id="box_unlockables"
        bg={bgColor[colorMode]}
        boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
        p="14px 15px"
        justifyContent="space-between"
        borderRadius={4}
        flexDirection="column"
        mb="35px"
      >
        <Flex borderBottomWidth={1} borderColor={colorMode === 'dark' ? '#333' : null} pb="5px">
          <Text fontSize="10px" fontWeight="600" color={colorMode === 'dark' ? 'gray.300' : '#161616'}>
            {unlockables?.length} ITEMS
          </Text>
        </Flex>
        {unlockables.map((i, index) => {
          return (
            <Flex
              key={index}
              flex="1"
              justifyContent="space-between"
              alignItems="center"
              p="10px"
              borderBottomWidth={1}
              borderColor={colorMode === 'dark' ? '#333' : null}
              _last={{ borderBottomWidth: 0 }}
            >
              <Flex id="info" alignItems="center">
                {i.file.file_type === 4 ? (
                  <IconButton
                    bg="#F7F5F5"
                    mr="15px"
                    borderRadius={8}
                    icon={<AiFillFile color="#012AFF" fontSize="20px" />}
                  />
                ) : (
                  <Image w="42px" h="42px" src={getIcon(i.file.file_type)} alt="" mr="15px" />
                )}

                <Box>
                  <Text fontSize="12px" fontWeight="600" mb="4px" color={colorMode === 'dark' ? 'gray.300' : '#161616'}>
                    {i.name}
                  </Text>
                  <Text fontSize="8px" fontWeight="500">
                    {getFormat(i.file.file_type)}
                  </Text>
                </Box>
              </Flex>
              {i.can_download && (
                <a href={getLink(i.file)} target="_blank" rel="noreferrer">
                  <IconButton
                    bg="#f7f5f5"
                    size="xs"
                    borderRadius={5}
                    aria-label="Search database"
                    icon={<GrDownload color="#161616" />}
                  />
                </a>
              )}
            </Flex>
          );
        })}
      </Flex>
    </Fragment>
  );
};
export default Unlockable;
